import { apiSlice } from './apiSlice';
import { USERS_URL } from '../constants';

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    login: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/auth`,
        method: 'POST',
        body: data,
      }),
    }),

    // Step 2 of login — submit the emailed OTP code
    verifyOtp: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/verify-otp`,
        method: 'POST',
        body: data,   // { email, otp }
      }),
    }),

    // FIX: was '/pReset' (capital R) — route is '/preset' (all lowercase),
    //      so this mutation was silently 404-ing on every password reset attempt
    pReset: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/preset`,
        method: 'POST',
        body: data,
      }),
    }),

    passwordReset: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/resetpass`,
        method: 'POST',
        body: data,
      }),
    }),

    register: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}`,
        method: 'POST',
        body: data,
      }),
    }),

    logout: builder.mutation({
      query: () => ({
        url: `${USERS_URL}/logout`,
        method: 'POST',
      }),
    }),

    profile: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/profile`,
        method: 'PUT',
        body: data,
      }),
    }),

    getUserProDetails: builder.query({
      query: (id) => ({
        url: `${USERS_URL}/profile/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),

    getUsers: builder.query({
      query: () => ({
        url: USERS_URL,
      }),
      providesTags: ['User'],
      keepUnusedDataFor: 5,
    }),

    getUsersManager: builder.query({
      query: (clinicalDirectorId) => ({
        url: `${USERS_URL}/managers/users/${clinicalDirectorId}`,
      }),
      providesTags: ['User'],
      keepUnusedDataFor: 5,
    }),

    getManagers: builder.query({
      query: () => ({
        url: `${USERS_URL}/managers`,
      }),
      providesTags: ['User'],
      keepUnusedDataFor: 5,
    }),

    deleteUser: builder.mutation({
      query: (userId) => ({
        url: `${USERS_URL}/${userId}`,
        method: 'DELETE',
      }),
    }),

    getUserDetails: builder.query({
      query: (id) => ({
        url: `${USERS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),

    updateUser: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/${data.userId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['User'],
    }),

    utilUpdateUser: builder.mutation({
      query: () => ({
        url: `${USERS_URL}/updateUserIDs`,
        method: 'PUT',
      }),
      invalidatesTags: ['User'],
    }),

    updateClinicalDirector: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/updateClinicalDirector`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['User'],
    }),

    getGroupedInformation: builder.query({
      query: () => ({
        url: `${USERS_URL}/groupedInformation`,
      }),
      providesTags: ['User'],
      keepUnusedDataFor: 5,
    }),

  }),
});

export const {
  usePResetMutation,
  usePasswordResetMutation,
  useLoginMutation,
  useLogoutMutation,
  useRegisterMutation,
  useProfileMutation,
  useGetUserProDetailsQuery,
  useGetUsersQuery,
  useGetManagersQuery,
  useDeleteUserMutation,
  useUpdateUserMutation,
  useGetUserDetailsQuery,
  useGetUsersManagerQuery,
  useUtilUpdateUserMutation,
  useGetGroupedInformationQuery,
  useUpdateClinicalDirectorMutation,
  useVerifyOtpMutation,
} = userApiSlice;

